import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=6bdc7afc&scoped=true&"
import script from "./TabItem.vue?vue&type=script&lang=ts&"
export * from "./TabItem.vue?vue&type=script&lang=ts&"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=6bdc7afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdc7afc",
  null
  
)

export default component.exports